module.exports = __webpack_public_path__ + "static/media/4.a4b98dd7.jpg";